<template>
  <el-dialog
    title="回收站"
    :visible.sync="visible"
    width="1000px"
    :close-on-click-modal="false"
    :append-to-body="true"
    @close="visible = false"
    @opened="$refs.table && $refs.table.doLayout()"
  >
    <div style="margin-bottom:12px;">
      <el-input
        v-model="searchName"
        placeholder="搜索属性名称"
        size="small"
        clearable
        style="width:220px;"
        @clear="loadData"
        @keyup.enter.native="handleSearch"
      >
        <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
      </el-input>
    </div>

    <el-table ref="table" :data="list" border size="small" v-loading="loading">
      <el-table-column label="属性名称" prop="name" min-width="140" show-overflow-tooltip></el-table-column>
      <el-table-column label="属性值类型" prop="valueTypeDesc" width="120"></el-table-column>
      <el-table-column label="备注" prop="remark" min-width="160" show-overflow-tooltip></el-table-column>
      <el-table-column label="创建人" prop="createUserName" width="100"></el-table-column>
      <el-table-column label="创建时间" prop="createTime" width="150">
        <template slot-scope="{ row }">{{ row.createTime | date-format }}</template>
      </el-table-column>
      <el-table-column label="状态" prop="enableFlagDesc" width="90" align="center">
        <template slot-scope="{ row }">
          <el-tag size="small" :type="row.enableFlag ? 'success' : 'info'" effect="plain">{{ row.enableFlagDesc }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="80" align="center" fixed="right">
        <template slot-scope="{ row }">
          <el-button v-if="$withPermission('attributeDict_restore')" type="text" size="mini" @click="handleRestore(row)">还原</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-bar">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :total="total"
        :page-size="pageSize"
        :current-page.sync="pageNum"
        @current-change="loadData"
      ></el-pagination>
    </div>
  </el-dialog>
</template>

<script>
import { getRecycleBinPageList, restoreAttribute } from '@/api/attributeDict.js';

export default {
  name: 'RecycleBinDialog',
  data () {
    return {
      visible: false,
      loading: false,
      searchName: '',
      list: [],
      total: 0,
      pageNum: 1,
      pageSize: 10,
      categoryTenantId: null,
      categoryPlatformId: null,
    };
  },
  methods: {
    open ({ categoryTenantId = null, categoryPlatformId = null } = {}) {
      this.categoryTenantId = categoryTenantId;
      this.categoryPlatformId = categoryPlatformId;
      this.searchName = '';
      this.pageNum = 1;
      this.visible = true;
      this.loadData();
    },
    handleSearch () {
      this.pageNum = 1;
      this.loadData();
    },
    loadData () {
      this.loading = true;
      getRecycleBinPageList({
        name: this.searchName || null,
        attributeCategoryTenantId: this.categoryTenantId || null,
        attributeCategoryPlatformId: this.categoryPlatformId || null,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      }).then(res => {
        if (res.heads.code === 200) {
          this.list = res.body?.list || [];
          this.total = res.body?.total || 0;
        }
      }).finally(() => { this.loading = false; });
    },
    handleRestore (row) {
      this.$confirm(`确定要还原属性「${row.name}」吗？`, '还原属性', {
        confirmButtonText: '还原',
        cancelButtonText: '取消',
        type: 'info',
      }).then(() => {
        restoreAttribute({ id: row.id }).then(res => {
          if (res.heads.code === 200) {
            this.$message.success('还原成功');
            this.loadData();
            this.$emit('restored');
          }
        });
      }).catch(() => {});
    },
  },
};
</script>

<style scoped lang="scss">
.pagination-bar {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
}
</style>
